import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

/**
 * Lifecycle pack — creation, modification, drift, retirement
 * attribution. Applies to every managed resource.
 */
export const networkLifecycleFieldPack: FieldPack = {
  id: 'network-lifecycle',
  name: 'Lifecycle',
  description: 'Creation, modification, drift, retirement',
  version: '1.0.0',
  dependencies: ['network-base'],
  fields: [
    {
      id: 'createdAt',
      label: 'Created At',
      type: FieldType.DATE,
      tags: ['lifecycle'],
      priority: 100,
      sensitivity: 'internal',
    },
    {
      id: 'createdBy',
      label: 'Created By',
      type: FieldType.TEXT,
      tags: ['lifecycle'],
      priority: 95,
      sensitivity: 'internal',
    },
    {
      id: 'lastModified',
      label: 'Last Modified',
      type: FieldType.DATE,
      tags: ['lifecycle'],
      priority: 90,
      sensitivity: 'internal',
    },
    {
      id: 'driftStatus',
      label: 'Drift Status',
      type: FieldType.SELECT,
      tags: ['lifecycle'],
      priority: 85,
      options: [
        { value: 'in-sync', label: 'In Sync' },
        { value: 'drift-detected', label: 'Drift Detected' },
        { value: 'unknown', label: 'Unknown' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'managedBy',
      label: 'Managed By',
      type: FieldType.SELECT,
      tags: ['lifecycle'],
      priority: 80,
      options: [
        { value: 'terraform', label: 'Terraform' },
        { value: 'cloudformation', label: 'CloudFormation' },
        { value: 'cdk', label: 'AWS CDK' },
        { value: 'pulumi', label: 'Pulumi' },
        { value: 'manual', label: 'Manual' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'sourceRepo',
      label: 'Source Repository',
      type: FieldType.TEXT,
      tags: ['lifecycle'],
      priority: 75,
      placeholder: 'github.com/acme/infra',
      sensitivity: 'internal',
    },
    {
      id: 'retirementDate',
      label: 'Retirement Date',
      type: FieldType.DATE,
      tags: ['lifecycle'],
      priority: 70,
      sensitivity: 'internal',
    },
  ],
};
